// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import directive from './directive'
import filters from '@/filters/index'
import echarts from 'echarts'
import '@/assets/font/iconfont.css';
import '@/assets/font/myIcon.css';
import { getDicts } from "@/api/dict/data";
import {DICT_TYPE, getDictDataLabel, getDictDatas, getDictDatas2} from "@/utils/dict";
import { parseTime, resetForm, handleTree, addBeginAndEndTime, divide} from "@/utils/util";

import './permission' // permission control
import i18n from './locales'

// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.getDictDatas = getDictDatas
Vue.prototype.getDictDatas2 = getDictDatas2
Vue.prototype.getDictDataLabel = getDictDataLabel
Vue.prototype.DICT_TYPE = DICT_TYPE
Vue.prototype.$echarts = echarts
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.handleTree = handleTree
Vue.prototype.addBeginAndEndTime = addBeginAndEndTime
Vue.prototype.divide = divide

// 默认点击背景不关闭弹窗
import ElementUI from 'element-ui'

ElementUI.Dialog.props.closeOnClickModal.default = false

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

Vue.use(Element, {
  size: localStorage.getItem("size") || "medium", // set element-ui default size
});

for(let key in filters){
  Vue.filter(key,filters[key]);
}
Vue.prototype.$filter = filters;

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

// import Print from 'print-js'
// Vue.use(Print);
// 全局组件挂载
Vue.component('DictTag', DictTag)
// 字典标签组件
import DictTag from '@/components/DictTag'
import QRcode from '@/components/QRcode'
Vue.use(QRcode);
import promptMessages from '@/components/messages';
Vue.use(promptMessages); // 表头提示自定义提示信息组件

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js